<template>
  <div>
    <v-card class="card-custom-shadow">
      <v-card-title class="text-h6">
        {{ $t("Đổi thời gian giao xe") }}
      </v-card-title>

      <v-card-subtitle class="fs-12">
        Chọn thời gian giao xe và xác nhận
      </v-card-subtitle>

      <v-card-text class="fs-12">
        <v-row dense>
          <v-col cols="4">
            <date-picker-model
              v-model="startDate"
              label="Ngày"
              custom-class="c-input-small"
              outlined
              dense
              hide-details
              :single-line="false"
              :min-date="minDate"
            ></date-picker-model>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="startHour"
              :items="hourOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Giờ"
            ></v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              v-model="startMinute"
              :items="minOptions"
              class="c-input-small"
              outlined
              dense
              hide-details
              label="Phút"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="close">
          {{ $t("Hủy") }}
        </v-btn>
        <v-btn color="green darken-1" text @click="confirmChanged">
          {{ $t("Xác nhận") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";
import moment from "moment/moment";

export default {
  name: "ChangeTime",
  components: {},
  props: {
    info: {
      type: Object,
      default: () => {},
    },
    isRenting: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    type: 1,
    file: null,
    image: {},
    isLoading: false,
    content: {},
    startDate: null,
    startHour: null,
    startMinute: null,
  }),
  watch: {},
  computed: {
    minDate() {
      return moment().format("YYYY-MM-DD");
    },
    startTime() {
      console.log(this.startDate, this.startHour, this.startMinute);
      if (!this.startDate || !this.startHour || !this.startMinute) {
        return null;
      }
      return `${this.startDate} ${this.startHour}:${this.startMinute}:00`;
    },
    hourOptions() {
      const today = moment().format("YYYY-MM-DD");
      const nowHour = moment().hour();
      let h = 0;
      if (this.startDate == today) {
        h = nowHour;
      }
      const hours = [];
      for (let i = 8; i < 21; i++) {
        if (i >= h) {
          hours.push(i < 10 ? `0${i}` : `${i}`);
        }
      }
      return hours;
    },
    minOptions() {
      const today = moment().format("YYYY-MM-DD");
      const nowHour = moment().hour();
      const nowMin = moment().minute();
      let m = 0;
      if (this.startDate == today && +this.startHour == nowHour) {
        m = nowMin;
      }
      const minutes = [];
      for (let i = 0; i < 60; i += 15) {
        if (i >= m) {
          minutes.push(i < 10 ? `0${i}` : `${i}`);
        }
      }
      return minutes;
    },
  },
  created() {
    if (this.info.payment_method) {
      this.type = this.info.payment_method;
    }
  },
  mounted() {},
  methods: {
    close() {
      this.$emit("close", true);
    },

    async confirmChanged() {
      if (!confirm("Bạn đã kiểm tra kỹ dữ liệu chưa?")) {
        return false;
      }

      if (this.isLoading) {
        this.$vToastify.warning(this.$t("messages.loading"));
        return false;
      }
      this.isLoading = true;
      try {
        await httpClient.post("/order/v1/change-start-time", {
          start_time: this.startTime,
          id: this.info.id,
        });
        this.isLoading = false;
        this.$emit("onOrderChanged", true);
        this.$vToastify.success("Cập nhật thành công");
        this.close();
      } catch (e) {
        this.isLoading = false;
        const errMsg =
          (e.response &&
            e.response.data &&
            e.response.data.error &&
            e.response.data.error.message) ||
          null;
        this.$vToastify.error(errMsg);
      }
    },
  },
};
</script>
